'use strict';
import React, { Component } from 'react'
import Iframe from 'react-iframe'

export default class CustomerDocument extends Component {
  constructor(props) {
    super(props)
    this.state = {
      minH: 100,
    }
    this.handleReceiveMessage = this.handleReceiveMessage.bind(this);
  }

  handleReceiveMessage(event) {
    const eventName = event && event.data && event.data.eventName;
    const payload = event && event.data && event.data.payload;

    if (eventName == 'SET_HEIGHT' && payload.height) {
      console.log('Event: ', event);
      var currentIFrameHeight = payload.height;
      this.setState({
        minH: currentIFrameHeight + 160
      })
    }
  }

  componentDidMount() {
    window.addEventListener('message', this.handleReceiveMessage);
  }

  componentWillUnmount() {
  }

  render() {
    let brand = "barri";
    let lang = this.props.locale;
    let slang = 'en-US';
    if (lang == 'es') slang = 'es-MX'

    let id = this.obtenerParametrosURL();
    let env = this.obtenerEnv();

    let url = '';
    if (env == 'prod') {
      if (id != null && id != "") {
        url = "https://cda.barri.com/?id=" + encodeURIComponent(id) + "&brand=" + encodeURIComponent(brand) + "&lang=" + encodeURIComponent(slang);
      } else {
        url = "https://cda.barri.com/?brand=" + encodeURIComponent(brand) + "&lang=" + encodeURIComponent(slang);
      }
    }

    if (env == 'test') {
      if (id != null && id != "") {
        url = "https://testl.barrigroup.com/?id=" + encodeURIComponent(id) + "&brand=" + encodeURIComponent(brand) + "&lang=" + encodeURIComponent(slang);
      } else {
        url = "https://testl.barrigroup.com/?brand=" + encodeURIComponent(brand) + "&lang=" + encodeURIComponent(slang);
      }
    }


    return (
      <div className="container" style={{ "marginTop": "10%", "marginBottom": "5%", "minHeight": this.state.minH }} >
        <Iframe url={url}
          id='miIFrame'
          width="90%"
          height='100%'
          className="container"
          display="block"
          frameBorder={0}
          position="relative"
          styles={{ "min-height": "inherit" }} />
      </div>
    )

  }

  obtenerParametrosURL() {
    //var urlParams = new URLSearchParams(this.props.location.search);

    if (typeof window !== 'undefined') {
      console.info('Window defined')
      let search = window.location && window.location.search || '';
      var id = search.split('id=')[1]
      console.log('Id: ', id)
      return id
    }
    return ''
  }
  obtenerEnv() {
    if (typeof window !== 'undefined') {
      console.info('Window defined')
      let hostname = window.location && window.location.hostname || '';
      if (hostname && (hostname.includes('barriqa') || hostname.includes('localhost'))) {
        return 'test'
      }
    }
    return 'prod'
  }

}



// WEBPACK FOOTER //
// ./js/customerDocuments.js